export default __webpack_public_path__ + "static/media/joint.946d34f9.png";